import EquipagesController from './equipages.controller';

export default {
    template: require('./equipages.html'),
    controller: EquipagesController
};
